<template>
	<div v-if="notification"
		 :class="[`notification flex fw9 f4 lh-title z-10 tc flex justify-center`,{error: isError}, $css(styles.notification)]">
		{{notification.text}}
	</div>
</template>

<script>
	import {mapState, mapActions} from "vuex";
	import config from "@/common/config";
	import consts from "@/common/consts";
	import {getInMediaQuery as gimq, MQ_SIZES} from "@/utils/cssUtils";
	import {types} from "@/store/modules/app";

	function styles() {
		return this.$style({
			notification: gimq(MQ_SIZES.D, {top: "140px"})
		});
	}

	export default {
		name: "Notification",
		data() {
			return {
				timeOutHandler: null,
			};
		},

		computed: {
			...mapState({
				notification: (state) =>
					state.app.notificationType ? {
						type: state.app.notificationType,
						text: state.app.notificationText
					} : null,
				isError: (state) =>
					state.app.notificationType === consts.NOTICE_TYPES.ERROR,
			}),
			styles,
		},

		methods: {
			...mapActions("app", [types.CLEAR_NOTIFICATION]),
			clearNotification() {
				this[types.CLEAR_NOTIFICATION]();
			},
		},

		updated() {
			if (this.timeOutHandler) {
				clearTimeout(this.timeOutHandler);
				this.timeOutHandler = null;
			}

			this.timeOutHandler =
				setTimeout(this.clearNotification.bind(this), config.notifications.timeout);
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../assets/scss/_variables.scss";

	.notification {
		min-width: 300px;
		max-width: 500px;
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		top: 80px;
		padding: 10px 20px;
		background: $lightGreen;
		color: $white;
		box-shadow: 1px 2px 2px 1px #00000099;

		&.error {
			background: $lightRed;
		}
	}
</style>
